import { inject, Injectable } from "@angular/core";
import { jkRestReturnClass } from "./jkClass";
import { jkLib } from "./jkCommon";
import { jkRestReturn } from "./jkInterface";
import { OrmService } from "./jkOrm";
import { login, LoginService } from "./jkUser";



@Injectable({
  providedIn: 'root',
})
export class StockTimeService{
    isHoliday: boolean = false;
    isYesterdayHoliday: boolean = false;
    FToday: string = '';
    title: string;
    FTime8 : string = jkLib.nowTime8();
    ret: jkRestReturn;
    orm: OrmService= inject(OrmService);
    login: LoginService; //= inject(LoginService);
    constructor(){
      this.login= login;
      this.title = '休息或無定時';
      this.ret = new jkRestReturnClass();
    }
    async updateHoliday(){
        if (this.FToday !== jkLib.nowDate()){
            this.FToday = jkLib.nowDate();
            this.isHoliday = await this.isBankHoliday(this.FToday);
            let mStr = jkLib.countDate(jkLib.nowDate(),'D',-1);
            this.isYesterdayHoliday = await this.isBankHoliday(mStr);
        }

    };
    async isBankHoliday(ADate: string):Promise<boolean>{
        let result = false;
        let year = ADate.substring(0,4);
        let  SQLSelect = `SELECT * FROM CMSMP WHERE MP001='2' AND MP002='${year}' AND MP004='${ADate}' AND MP005>='1' `;
          // 0005 MP005    休假方式                    V   01   0.工作日 1.休息日 3.例假日 4.國定假日
        let ds = await this.orm.simpleSqlPromise(this.login.host ,SQLSelect,this.ret);
        if (ds.length > 0){
            result = true;
        }
        return result;
    };
    isStockDay(): boolean{
      let result = false;
      if ((this.FTime8 >= '08:45:00') && (this.FTime8 <= '13:45:00')){
        if(this.isHoliday){
          this.title = '假日';
        }else{
          this.title = '日盤';
          result = true;
        }
      };
      return result;
    }
    isStockNight(): boolean{
      let result = false;
      if (((this.FTime8 >= '15:00:00') && (this.FTime8 <= '23:59:59')) ||
        ((this.FTime8 >= '00:00:00') && (this.FTime8 <= '05:00:00'))) {

        }
        this.title = '夜盤';
        result = true;
        if(this.isHoliday){
            this.title = '假日';
        };
        return result;
    };
}



//export const stockTime: StockTimeService = new StockTimeService(); // ### jackie add
